var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 28,
    viewBox: "0 0 6 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.580078,
    width: 6,
    height: 27,
    rx: 3,
    fill: "#FFAD5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMenuIcon);
export default __webpack_public_path__ + "static/media/SelectedMenuIcon.de9ad37e1cdce58d1b9b61b07d96321c.svg";
export { ForwardRef as ReactComponent };